const partMasterConfig = [
  {
    name: "Part_Master_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Part_Number",
        label: "Part Number",
        type: "text",
        min: 2,
        // isRequired: true,
        AllCaps: true,
        // ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Part_Name",
        label: "Part Name",
        type: "text",
        min: 2,
        isRequired: true,
        FirstCharCap: true,
        ValidationType: "VALID_STRING",
      },
      {
        id: Math.random() * 10,
        name: "Content",
        label: "Content",
        type: "text",
        min: 2,
        // isRequired: true,
        FirstCharCap: true,
      },
      {
        id: Math.random() * 10,
        name: "Customer_Account",
        label: "Customer Name",
        type: "InputDropForQuery",
        masterName: "ERPAddressBook",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Dimension",
            label: "Dimension(L×W×H)",
            type: "inputMask",
            mask: "99 x *9 x *9",
            inputBoxNumber: 3,
            inputDigitLimit: 3,
            min: 1,
            max: Infinity,
            // type:"DimensionsMask",
          },
          {
            id: Math.random() * 10,
            name: "Inc_CMS",
            label: "Inc/CMS",
            type: "inputdrop",
            dropdowncontent: ["in", "cm"],
            min: 1,
            max: Infinity,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Packaging",
        label: "Packaging",
        type: "InputDropForQuery",
        masterName: "searchPackaging",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Quantity_Per_Box",
        label: "Quantity Per Box",
        type: "number",
        min: 1,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Weight",
        label: "Actual Weight (Per Article)",
        type: "number",
      },
    ],
  },
];

export { partMasterConfig };
